/**
 * AI生成プロフィール入力ステップ
 */
import { GenerationStatus } from "features/player/types";
import { GenderStep } from "./GenderStep";
import { BirthdayStep } from "./BirthdayStep";
import { FavoritesStep } from "./FavoritesStep";
import { IconPreviewStep } from "./IconPreviewStep";
import { PlayerProfileSubStepBar } from "../../components";
import { CreatePlayerState, PlayerProfileSubStep, PlayerFavoritesSubStep } from "../../types";

interface PlayerProfileAIStepProps {
  state: CreatePlayerState;
  updateState: (updates: Partial<CreatePlayerState>) => void;
  currentSubStep: PlayerProfileSubStep;
  generationStatus: GenerationStatus;
  generationProgress: number;
  generatedImage: string | null;
  partialImage: string | null;
  favoritesSubStep: PlayerFavoritesSubStep;
  onSubStepNext: () => void;
  onSubStepClick: (
    targetSubStep: PlayerProfileSubStep,
    targetFavoritesSubStep?: PlayerFavoritesSubStep,
  ) => void;
  // 追加プロンプト関連
  additionalPrompt?: string;
  onAdditionalPromptChange?: (prompt: string) => void;
  onRegenerate?: () => void;
  // サブステップバー用
  completedStepIds?: string[];
  isGenerating?: boolean;
  /** 狭い画面向け: サブステップバーをドットのみ表示にする */
  compact?: boolean;
  /** 狭い画面向け: フォーム内のグリッドを折返しレイアウトに切り替える */
  narrow?: boolean;
}

export const PlayerProfileAIStep = ({
  state,
  updateState,
  currentSubStep,
  generationStatus,
  generationProgress,
  generatedImage,
  partialImage,
  favoritesSubStep,
  onSubStepClick,
  additionalPrompt,
  onAdditionalPromptChange,
  onRegenerate,
  completedStepIds,
  isGenerating,
  compact = false,
  narrow = false,
}: PlayerProfileAIStepProps) => {
  const renderContent = () => {
    switch (currentSubStep) {
      case PlayerProfileSubStep.GENDER:
        return <GenderStep state={state} updateState={updateState} />;
      case PlayerProfileSubStep.BIRTHDAY:
        return <BirthdayStep state={state} updateState={updateState} narrow={narrow} />;
      case PlayerProfileSubStep.FAVORITES:
        return (
          <FavoritesStep
            state={state}
            updateState={updateState}
            favoritesSubStep={favoritesSubStep}
            narrow={narrow}
          />
        );
      case PlayerProfileSubStep.ICON_PREVIEW:
        return (
          <IconPreviewStep
            status={generationStatus}
            progress={generationProgress}
            generatedImage={generatedImage}
            partialImage={partialImage}
            additionalPrompt={additionalPrompt}
            onAdditionalPromptChange={onAdditionalPromptChange}
            onRegenerate={onRegenerate}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="flex-row-el w-full min-h-full">
      {/* サブステップ進捗バー（左側） */}
      <PlayerProfileSubStepBar
        currentSubStep={currentSubStep}
        favoritesSubStep={favoritesSubStep}
        onStepClick={onSubStepClick}
        completedStepIds={completedStepIds}
        isGenerating={isGenerating}
        compact={compact}
      />

      {/* コンテンツ（右側・中央揃え） */}
      <div className="flex-col-el items-center flex-1 min-h-0 overflow-y-auto invisible-scrollbar">
        {renderContent()}
      </div>
    </div>
  );
};
